import { defineComponent as Q, useSlots as he, toRefs as Ee, reactive as O, useAttrs as Ie, ref as p, computed as f, onMounted as D, onUpdated as ge, watch as I, openBlock as n, createElementBlock as s, normalizeClass as ke, unref as a, toDisplayString as g, createCommentVNode as i, createElementVNode as k, mergeProps as j, createVNode as Le, createBlock as y, renderSlot as $, createTextVNode as ye, nextTick as N } from "vue";
import M from "../text-display/text-display.vue.js";
import { TEXT_DISPLAY_VARIANTS as w } from "../text-display/text-display-variants.js";
import { getUniqueId as be } from "../../unique-id/index.js";
import { useIMask as Se } from "vue-imask";
import { TEXT_INPUT_VARIANTS as r } from "./text-input-variants.js";
import q from "../sequiter-image/sequiter-image.vue.js";
import { ICONS as G } from "../sequiter-image/icon-library.js";
import { newImageModel as Y } from "../sequiter-image/image-model.js";
import { TextareaHeightMeasurementManager as xe } from "./textarea-height-measurement-manager.js";
import { ComponentSetupError as J } from "../../errors/component-setup-error.js";
import { INPUT_WIDTH as Ae } from "../imask.js";
import { useTheme as _e, onThemeLoaded as De } from "../../themes/injection.js";
import { ErrorLoggerInjectionFacade as Ne } from "../../injection/error-logger-injection-facade.js";
import { ScreenSize as Me } from "../../user-agent/screensize.js";
const we = ["for"], Re = { class: "inline-wrapper" }, Ve = { key: 0 }, Pe = { class: "placeholder-label-wrapper" }, Be = ["for"], He = ["id", "value", "autocomplete", "rows"], Ce = ["id", "type", "value", "autocomplete"], We = { class: "measuring-div-wrapper" }, Ue = ["for"], Xe = { class: "btn-cal" }, ze = { key: 3 }, K = Ae.LARGE, Fe = Q({
  name: "text-input",
  // To support masking, we pass all non-prop attributes down to the inner input
  inheritAttrs: !1
}), nt = /* @__PURE__ */ Q({
  ...Fe,
  props: {
    label: {},
    modelValue: {},
    maskPreset: {},
    mask: {},
    unmask: { type: Boolean, default: !1 },
    prefix: {},
    suffix: {},
    example: {},
    extendedHelp: {},
    error: {},
    inputWidth: { default: K },
    variant: { default: r.SINGLE_LINE },
    lazy: { type: Boolean, default: !0 },
    autocomplete: {}
  },
  emits: ["update:modelValue", "focus", "blur", "input"],
  setup(Z, { expose: ee, emit: L }) {
    const t = Z, te = he(), { class: ae, ...oe } = Ee(
      // This call to reactive shouldn't be necessary as the result of useAttrs is already reactive.
      // But without this Vue gives a warning for the toRefs call saying it's not a reactive object.
      O(Ie())
    ), b = O(oe), R = new Ne().useInjection(), V = new Me().isMediumOrLarger, P = p(void 0), l = p(void 0), re = p(void 0), S = p(void 0), ne = f(
      () => t.variant !== r.MULTI_LINE && t.variant !== r.EDITABLE_TEXT
    ), ie = f(
      () => t.variant !== r.MULTI_LINE && t.variant !== r.EDITABLE_TEXT
    ), u = p(t.modelValue), T = be(t.label);
    function B() {
      t.suffix && te.complexSuffix && R.logError(
        new J(
          "text-input",
          "cannot have both a complexSuffix and suffix"
        )
      );
    }
    D(B), ge(B), I(
      [() => t.variant, () => t.inputWidth],
      ([e, o]) => {
        e === r.EDITABLE_TEXT && o !== K && R.logError(
          new J(
            "text-input",
            `EDITABLE_TEXT variant does not support setting the input width, but a width was set (${o})`
          )
        );
      },
      { immediate: !0 }
    );
    const le = f(() => t.variant === r.PASSWORD || t.variant === r.DATE ? t.variant : "text"), v = p(!1);
    function H(e) {
      v.value = !0, t.variant === r.EDITABLE_TEXT && e.target.select(), L("focus", e);
    }
    function ue(e) {
      e.target?.closest(".text-input")?.querySelector("input, textarea")?.focus();
    }
    function C(e) {
      v.value = !1, u.value = t.modelValue, L("blur", e);
    }
    const x = _e(), se = x?.isSlateV1 ? "1" : "2", W = f(() => u.value !== void 0), A = f(() => W.value ? _.value ? c?.value ?? u.value : u.value : "");
    function U(e) {
      L("update:modelValue", e), N(() => {
        E(l.value);
      });
    }
    function X(e) {
      u.value = e.target.value, U(u.value), L("input", e);
    }
    I(
      () => t.modelValue,
      (e) => {
        v.value || (u.value = e), _.value && (t.unmask ? h !== void 0 && e !== void 0 && (h.value = e ?? "") : c !== void 0 && e !== void 0 && (c.value = e ?? ""));
      }
    );
    const _ = f(() => t.mask || t.maskPreset);
    let m = p(void 0), h, c;
    _.value && ({
      el: m,
      unmasked: h,
      masked: c
    } = Se(
      {
        mask: t.mask,
        lazy: t.lazy,
        ...b,
        ...t.maskPreset
      },
      {
        // Provide a callback for the accept event.
        onAccept() {
          U(t.unmask ? h?.value ?? "" : c?.value ?? "");
        }
      }
    ), I(m, (e) => {
      e && (e.maskProperties = {
        unmasked: h,
        masked: c
      });
    }));
    const z = f(() => x?.isSlateV4 && V.value), fe = f(() => ({
      resize: z?.value ? "both" : "none",
      ...z?.value ? void 0 : { width: void 0 }
    }));
    function de() {
      return t.variant === r.MULTI_LINE && (x?.isSlateV1 || !V.value);
    }
    function E(e) {
      de() && e && new xe(e, S.value).fitHeightToText();
    }
    I(v, (e) => {
      e === !1 && E(l.value);
    }), De(() => {
      E(l.value);
    }), D(() => {
      E(l.value);
    }), window.addEventListener("resize", () => {
      E(l.value);
    });
    async function pe() {
      const e = S.value, o = P.value;
      if (!e || !o)
        return;
      await Promise.all([
        // Ensures the font of the measuring div has loaded, or the width we measure will be incorrect.
        document.fonts.ready,
        // Ensures the measuringDiv has the content from any recent changes
        N()
      ]);
      const d = e.querySelector(
        ".placeholder-label-wrapper"
      );
      d.style.maxWidth = o.clientWidth + "px";
    }
    const F = () => {
      t.variant === r.EDITABLE_TEXT && pe();
    };
    D(F), I(A, F);
    function ve() {
      m.value?.focus(), l.value?.focus();
    }
    function me() {
      m.value?.blur(), l.value?.blur();
    }
    async function ce(e) {
      u.value = e, await N();
    }
    function Te(e, o) {
      m.value?.setSelectionRange(e, o), l.value?.setSelectionRange(e, o);
    }
    return ee({ focus: ve, blur: me, forceInputValue: ce, setSelectionRange: Te }), (e, o) => (n(), s("div", {
      class: ke([
        e.$options.name,
        ne.value ? `input-width-${e.inputWidth}` : "",
        e.variant,
        {
          "has-content": v.value || e.modelValue,
          "has-focus": v.value
        },
        a(ae)
      ]),
      ref_key: "containerRef",
      ref: S
    }, [
      e.label && e.variant !== a(r).MULTI_LINE ? (n(), s("label", {
        key: 0,
        for: a(T),
        class: "top-label"
      }, g(e.label), 9, we)) : i("", !0),
      k("div", Re, [
        e.prefix ? (n(), s("span", Ve, g(e.prefix), 1)) : i("", !0),
        k("div", Pe, [
          e.label && e.variant !== a(r).MULTI_LINE ? (n(), s("label", {
            key: 0,
            for: a(T),
            class: "placeholder-label"
          }, g(e.label), 9, Be)) : i("", !0),
          e.variant === a(r).MULTI_LINE ? (n(), s("textarea", j({ key: 1 }, b, {
            id: a(T),
            value: W.value ? u.value : "",
            autocomplete: t.autocomplete,
            onInput: o[0] || (o[0] = (d) => X(d)),
            onFocus: o[1] || (o[1] = (d) => H(d)),
            onBlur: C,
            ref_key: "textArea",
            ref: l,
            rows: a(se),
            style: fe.value
          }), null, 16, He)) : (n(), s("input", j(
            {
              key: 2,
              ref_key: "singleLineInput",
              ref: m,
              id: a(T),
              type: le.value,
              value: A.value,
              autocomplete: t.autocomplete
            },
            e.mask || e.maskPreset ? {} : {
              // These bindings would conflict with the mask reference, so we only bind if no mask ref would be bound (see onAccept from the mask declaration)
              ...b,
              onInput: X
            },
            {
              onFocus: o[2] || (o[2] = (d) => H(d)),
              onBlur: C
            }
          ), null, 16, Ce)),
          k("div", We, [
            k("div", {
              ref_key: "measuringDivRef",
              ref: P,
              class: "measuring-div"
            }, g(A.value), 513)
          ]),
          ie.value ? (n(), s("div", {
            key: 3,
            class: "line-decorator",
            ref_key: "lineDecorator",
            ref: re
          }, null, 512)) : i("", !0)
        ]),
        e.variant === a(r).DATE ? (n(), s("label", {
          key: 1,
          for: a(T)
        }, [
          k("button", Xe, [
            Le(q, {
              "image-obj": a(Y)(a(G).CALENDAR_ICON, "Calendar")
            }, null, 8, ["image-obj"])
          ])
        ], 8, Ue)) : i("", !0),
        e.variant === a(r).EDITABLE_TEXT ? (n(), y(q, {
          key: 2,
          class: "edit-icon",
          "image-obj": a(Y)(a(G).PENCIL_LINE, "Edit"),
          onClick: ue
        }, null, 8, ["image-obj"])) : e.suffix || e.$slots.complexSuffix ? (n(), s("span", ze, [
          e.suffix ? i("", !0) : $(e.$slots, "complexSuffix", { key: 0 }, void 0, !0),
          ye(" " + g(e.suffix), 1)
        ])) : i("", !0),
        e.extendedHelp ? (n(), y(M, {
          key: 4,
          class: "extended-help",
          variant: a(w).HOVER_HELP,
          hoverText: e.extendedHelp
        }, null, 8, ["variant", "hoverText"])) : i("", !0)
      ]),
      $(e.$slots, "inputAttachment", {}, void 0, !0),
      e.example ? (n(), y(M, {
        key: 1,
        variant: a(w).HELP_TEXT,
        text: e.example
      }, null, 8, ["variant", "text"])) : i("", !0),
      e.error ? (n(), y(M, {
        key: 2,
        variant: a(w).ERROR,
        text: e.error
      }, null, 8, ["variant", "text"])) : i("", !0)
    ], 2));
  }
});
export {
  nt as default
};
//# sourceMappingURL=text-input.vue2.js.map
